// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".work-item{margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid #e6e6e6}.work-item:last-child{border-bottom:none;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
